"use client";

import { useEffect } from "react";

type ErrorFallbackProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export function ErrorFallback({ error, reset }: ErrorFallbackProps) {
  useEffect(() => {
    console.error("Unhandled application render error:", error);
  }, [error]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-950 px-6 text-gray-50">
      <div className="max-w-md text-center">
        <p className="text-sm font-medium uppercase tracking-[0.2em] text-platform-muted">
          CloserPro
        </p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight">Something went wrong</h1>
        <p className="mt-4 text-sm leading-6 text-platform-muted">
          We could not load this page. Try again, and contact support if the problem continues.
        </p>
        {error.digest ? (
          <p className="mt-2 text-xs text-platform-muted">Reference: {error.digest}</p>
        ) : null}
        <button
          type="button"
          onClick={reset}
          className="mt-6 rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-950 transition-colors hover:bg-gray-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
          Try again
        </button>
      </div>
    </main>
  );
}
